import { $themeConfig } from '@themeConfig'

const STORAGE_KEY = 'verticalMenuCollapsed'

const getInitialCollapsedState = () => {
  const stored = localStorage.getItem(STORAGE_KEY)
  if (stored !== null) {
    return stored === 'true'
  }
  return $themeConfig.layout.menu.isCollapsed
}

export default {
  namespaced: true,
  state: {
    isVerticalMenuCollapsed: getInitialCollapsedState(),
  },
  getters: {},
  mutations: {
    UPDATE_VERTICAL_MENU_COLLAPSED(state, val) {
      state.isVerticalMenuCollapsed = val
      localStorage.setItem(STORAGE_KEY, val)
    },
  },
  actions: {},
}
